import React from 'react'
import circle from '../images/circle.svg'

function LiveSvg() {
  return (
    <div className="absolute -top-1 left-1/2 -translate-x-1/2 z-50">
    <div className="flex items-center gap-2 bg-white px-3 py-1 rounded-full shadow-lg border border-gray-300">
      <span className="text-[#202020] font-medium text-xs">Live</span>
      <img src={circle} alt="Live indicator" width="8" height="9" />
    </div>
  </div>
  )
}

export default LiveSvg